import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { getModel } from "backend/model/getModel";
import { getPeriodLevels } from "backend/model/getPeriodLevels";
import { getPeriods } from "backend/model/getPeriods";
import { IPeriodLevel } from "backend/model/model";
import { useQuery } from "react-query";

const usePeriodLevels = (periodLevel?: string) => {
  const ctx = useAppContext();
  return useQuery<IPeriodLevel[]>(
    `periodlevel-${ctx.model}-${periodLevel || ""}`,
    async () => {
      const [model] = await getModel(ctx.model || "");
      const levels = await getPeriodLevels(model.id); //   await m.getPeriodLevels(model.id);
      const periods = (await getPeriods(model.id))
        .filter((p) => {
          if (periodLevel) {
            if (p.periodlevel === periodLevel) return true;
            return false;
          }
          return true;
        })
        .sort((a, b) => a.startdate.localeCompare(b.startdate));

      console.log("levels ", levels);
      return levels.map((level) => {
        return {
          id: level.id,
          name: level.name,
          periods: periods.filter((p) => p.periodlevel === level.id),
        };
      });
    },
    {
      enabled: true,
      cacheTime: 30 * (60 * 1000),
      staleTime: 30 * (60 * 1000),
    }
  );
};

export default usePeriodLevels;
